import videojs from 'video.js';
import Config from '../services/config';
import eventsSrv from '../services/events';
import vjsSrv from '../services/vjsSrv';

export class QualitySelectorService {
  constructor() {
    this.options = { default_auto: true };

    this.representations = [];
    this.menuItems = [];
    this.selectedIndex = 0;
    this.autoBitrateLabel = 'Auto';
    this.restrictQualityByUserScreen = false; // todo:

    if (Config.get('params.controlBar.QualitySelectorButton')) {
      eventsSrv.on('videoBitrateChanged', (event, data) => {
        this.updateItemsState();
      });
      eventsSrv.on('app_representation_loads', (event, data) => {
        if (this.restrictQualityByUserScreen) {
          this.representations = this.filterItemsForScreen(vjsSrv.vjsPlayer.TechSrv.getRepresentations());
        } else {
          this.representations = vjsSrv.vjsPlayer.TechSrv.getRepresentations();
        }
        if (vjsSrv.vjsPlayer.controlBar?.QualitySelectorButton) {
          vjsSrv.vjsPlayer.controlBar.QualitySelectorButton.update();
        }
      });
    }
  }

  filterItemsForScreen(items) {
    let screenHeight = 'screen' in window ? screen.height * (window.devicePixelRatio || 1) : window.innerHeight;
    let screenWidth = 'screen' in window ? screen.width * (window.devicePixelRatio || 1) : window.innerWidth;

    return items.filter((item) => {
      if ((item.height <= screenHeight && item.width <= screenWidth) ||
        (item.height <= screenWidth && item.width <= screenHeight)) {
        return true;
      } else {
        item.enabled(false);
        return false;
      }
    });
  };

  getTitleForAutoB() {
    // вернёт строку формата: <span style="font-size: 0.9em;">360p</span>
    let activeBitrate = vjsSrv.vjsPlayer.TechSrv.activeBitrate;
    let autoBitrateLabel = this.autoBitrateLabel;
    autoBitrateLabel = autoBitrateLabel + '(<span style="font-size: 0.9em;">' +
      (activeBitrate ? activeBitrate.height + 'p' : '') + '</span>)';
    return autoBitrateLabel;
  }

  updateAutoButton(button, title) {
    // обновит выбранной кнопке тайтл и значение
    if (button) {
      button.controlText(title);
      button.el_.firstElementChild.innerHTML = title;
      button.options_.label = title;
    }
  }

  formatBitrateLabel(item) {
    let bitrate = (item.bandwidth / 1000).toFixed(); // bandwidth - пропускная способность
    return '<span class="advance-b-label">' + item.width + 'x' + item.height + ' - ' + bitrate + 'kbps</span>' +
      '<span class="short-b-label">' + (item.height || 0) + 'p' + '</span>';
  }

  updateItemsState() {
    this.menuItems.map((item) => {
      if (this.selectedIndex === 0) { // auto bitrate, enable for all
        if (item.options_.index !== 0) {
          this.representations[item.options_.index - 1].enabled(true, true);
          item.selected(false);
        } else {
          item.selected(true);
        }
      } else { // specific bitrate
        if (item.options_.index === 0) {
          item.selected(false);
          this.updateAutoButton(item, this.autoBitrateLabel);
        } else if (item.options_.index === this.selectedIndex) {
          item.selected(true);
          this.representations[item.options_.index - 1].isEnabled_ = false;
          this.representations[item.options_.index - 1].enabled(true);
        } else {
          item.selected(false);
          this.representations[item.options_.index - 1].enabled(false);
        }
      }
    });
    if (this.selectedIndex === 0) {
      this.updateAutoButton(this.menuItems[0], this.getTitleForAutoB());
    }
  }

}

let MenuItem = videojs.getComponent('MenuItem');
let MenuItemButton = videojs.extend(MenuItem, {
  constructor: function(player) {
    MenuItem.apply(this, arguments);
  },
  handleClick() {
    this.player().QualitySelectorSrv.selectedIndex = this.options_.index;
    this.player().QualitySelectorSrv.updateItemsState();
  }
});
let MenuButton = videojs.getComponent('MenuButton');
let QualitySelectorButton = videojs.extend(MenuButton, {
  constructor: function(player) {
    player.QualitySelectorSrv = player.QualitySelectorSrv || new QualitySelectorService();
    MenuButton.apply(this, arguments);
    this.hide();
  },
  controlText() {
    return 'Quality change';
  },
  createItems() {
    let menuItems = [];
    let representations = this.player().QualitySelectorSrv.representations;
    if (representations.length <= 1) {
      return menuItems;
    }
    for (let i = 0; i !== representations.length; i++) {
      let item = representations[i];
      item.enabled(true);
      let btn = new MenuItemButton(this.player(), {
        label: '',
        index: i + 1,
        bandwidth: item.bandwidth,
        selected: false,
        selectable: true
      });
      btn.el_.querySelector('.vjs-menu-item-text').innerHTML = this.player().QualitySelectorSrv.formatBitrateLabel(item);
      menuItems.push(btn);
    }
    menuItems = menuItems.reverse();
    if (representations.length >= 2) {
      let btn = new MenuItemButton(this.player(), {
        label: '',
        index: 0,
        selected: true,
        selectable: true
      });
      btn.el_.querySelector('.vjs-menu-item-text').innerHTML = this.player().QualitySelectorSrv.getTitleForAutoB();
      menuItems.unshift(btn);
    }
    this.player().QualitySelectorSrv.menuItems = menuItems;
    return menuItems;
  },
  buildCSSClass: function buildCSSClass() {
    return MenuButton.prototype.buildCSSClass.call(this) + ' vjs-icon-cog';
  },
  update: function update() {
    return MenuButton.prototype.update.call(this);
  },
  createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-menu-button vjs-quality-menu vjs-menu-button-popup vjs-control vjs-button'
    });
  }
});
videojs.registerComponent('QualityMenuItem', MenuItemButton);
videojs.registerComponent('QualitySelectorButton', QualitySelectorButton);
